export default {
	name: 'Convention.Registration.Transfer',
	path: 'convention/registration/transfer',
	meta: {
		auth: true,
		parents: ['Convention.Registration.Badge'],
		topLevel: true
	}
}